import React from 'react';

export const SCORE_AREA_LABELS = {
    DATA_STALL: 'Data Stall',
    SIGNAL: 'Signal',
    REGISTRATION: 'Registration',
    PDN: 'PDN',
    THROUGHPUT: 'Throughput',
    CPU: 'CPU',
    MEMORY: 'Memory',
    FLASH: 'Flash',
    THERMAL: 'Thermal',
    STABILITY: 'Stability',
    SSR: 'System Restart',
    BOOT: 'Boot',
};

export const SCORE_AREA_KEYS = Object.keys(SCORE_AREA_LABELS);

export const SCORE_SERIES_COLORS = [
    '#1a73e8', '#dc2626', '#d97706', '#059669', '#7c3aed', '#0891b2',
    '#be123c', '#4f46e5', '#65a30d', '#9333ea', '#0f766e', '#c2410c',
];

export const AREA_LINE_STYLES = [
    { borderDash: [8, 4], pointRadius: 2, pointStyle: 'circle' },
    { borderDash: [3, 3], pointRadius: 2, pointStyle: 'rectRounded' },
    { borderDash: [12, 4, 2, 4], pointRadius: 2, pointStyle: 'triangle' },
    { borderDash: [2, 4], pointRadius: 2, pointStyle: 'rect' },
    { borderDash: [10, 3, 2, 3, 2, 3], pointRadius: 2, pointStyle: 'star' },
];

export function getDefaultVisibleSeriesKeys(series) {
    return new Set(series
        .filter((item, index) => index === 0 || item.key === 'subdomain:STABILITY')
        .map((item) => item.key));
}

export function SeriesActionButtons({ series, visibleKeys, onSelectAll, onUnselectAll }) {
    return (
        <div className="fleet-trend-series-actions">
            <button type="button" onClick={onSelectAll} disabled={visibleKeys.size === series.length}>Select all</button>
            <button type="button" onClick={onUnselectAll} disabled={visibleKeys.size === 0}>Unselect all</button>
        </div>
    );
}

export function SeriesControls({ series, visibleKeys, onToggle, ariaLabel = 'Score trend legend' }) {
    return (
        <div className="fleet-trend-series-controls" role="group" aria-label={ariaLabel}>
            {series.map((item) => {
                const visible = visibleKeys.has(item.key);
                const hasData = item.hasData !== false;
                const unavailableMessage = 'No data is available in the selected time range for this area.';
                return (
                    <span key={item.key} title={hasData ? undefined : unavailableMessage}>
                        <button
                            type="button"
                            className={`fleet-trend-series-toggle${visible ? ' selected' : ''}${hasData ? '' : ' no-data'}`}
                            aria-pressed={visible}
                            aria-label={hasData ? item.name : `${item.name}: ${unavailableMessage}`}
                            disabled={!hasData}
                            onClick={() => onToggle(item.key)}
                        >
                            <span
                                className="fleet-trend-series-swatch"
                                style={{
                                    backgroundColor: item.borderDash?.length ? 'transparent' : item.color,
                                    backgroundImage: item.borderDash?.length
                                        ? `repeating-linear-gradient(to right, ${item.color} 0 5px, transparent 5px 9px)`
                                        : undefined,
                                }}
                            />
                            <span>{item.name}</span>
                        </button>
                    </span>
                );
            })}
        </div>
    );
}
